import { useCookieConsentStore } from '@/stores/cookieConsentStore';

/** A configured key is not visitor consent. Never load the tracker before both exist. */
export function initializeAnalyticsConsent() {
  const config = (window as Window & { ORIFLUX_CONFIG?: { key?: string; endpoint?: string } })
    .ORIFLUX_CONFIG;
  if (!config?.key) return () => {};
  let loaded = false;
  const sync = () => {
    const { hasConsented, preferences } = useCookieConsentStore.getState();
    if (hasConsented && preferences.analytics) {
      if (loaded) return;
      loaded = true;
      const endpoint = config.endpoint || 'https://in.oriflux.sponge-theory.dev';
      const script = document.createElement('script');
      script.id = 'neokanban-analytics';
      script.defer = true;
      script.src = `${endpoint}/v1/oriflux.js`;
      script.setAttribute('data-key', config.key!);
      script.setAttribute('data-endpoint', endpoint);
      document.head.appendChild(script);
    } else if (loaded) {
      // Removing a script cannot stop its existing listeners/timers. Reload after
      // Zustand persist writes the withdrawal, so no tracker runs in the new page.
      loaded = false;
      queueMicrotask(() => window.location.reload());
    }
  };
  sync();
  return useCookieConsentStore.subscribe(sync);
}
